import React, { useEffect } from "react";
import { useState } from "react";
import { Table, Form } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../../../../constants/index";
import { FaSpinner } from "react-icons/fa";
import { GetServiceCaller } from "../../../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../../constants/layout/store/filterSlice";


const ViewCategoryDesignationForm = () => {
  const [pageLoading, setPageLoading] = useState(true);
  const { categoryId } = useParams();
  const { questionId } = useParams();
  const [formDetails, setformDetails] = useState("");
   
  // const history = useHistory();
  const navigate = useNavigate();
  useEffect(() => {
    fetchDetails();
  }, []);

 
  const fetchDetails = async () => {
    try {
      setPageLoading(true); 
      const response = await GetServiceCaller(
        `${API_URL}view-category-data/${categoryId}/${questionId}`
      );
      if (response.status === 200) {
        setformDetails(response?.data);
      } else {
        console.error(
          "Failed to fetch job details. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching job details:", error);
    }
    finally {
    setPageLoading(false); // stop loader
  }
    // }
  };
  
  console.log("formDetail",formDetails.CategoryName);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("View PR Category Question Weightage Master"))
  }, [])
  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
     // Safety check
  if (!formDetails) {
    return <p className="text-center">No data found</p>;
  }
    return (
           <div className="container mt-4">
      <div className="card shadow p-4">

        {/* CATEGORY & QUESTION */}
        <div className="row mb-3">
          <div className="col-md-6">
            <label className="fw-bold">Category</label>
            <div className="form-control bg-light">
              {formDetails.CategoryName}
            </div>
          </div>

          <div className="col-md-6">
            <label className="fw-bold">Question</label>
            <div className="form-control bg-light">
              {formDetails.QuestionName}
            </div>
          </div>
        </div>

        {/* TABLE */}
        {formDetails.line?.length > 0 && (
          <table  className="table table-bordered mt-3 text-center">
            <tbody>
              {/* Group Row */}
              <tr  id="thcolor" className="table-light">
                <th>Group</th>
                {formDetails.line.map((row, index) => (
  <td
    key={index}
    className="tooltip-cell"
    style={{
      width: "150px",
      maxWidth: "150px",
      cursor: "pointer",
      fontWeight: "bold",
    }}
  >
    {/* Visible text */}
    <span className="cell-text">
      {row.GroupName}
    </span>

    {/* Hover text (index-based) */}
    <span className="custom-tooltip">
      {formDetails.designation?.[index]?.Name || ""}
    </span>
  </td>
))}

              </tr>

              {/* Weightage Row */}
              <tr>
                <th>Weightage</th>
                {formDetails.line.map((row, index) => (
                  <td key={index}>{row.Weightage}</td>
                ))}
              </tr>
            </tbody>
          </table>
        )}

        {/* BACK BUTTON */}
        <div className="text-end mt-3">
          <button
            className="cancel-btn me-2"
            onClick={() => navigate(-1)}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
    );
};
      
};

export default ViewCategoryDesignationForm;